<div class='table table-striped col'>
    <div class='table-header row secondary-color text-white mt-3'>
        <div class="cell-data col-8 col-md-9" *ngIf="!HasThirdColumn">Question</div>
        <div class="cell-data col-4 col-md-3" *ngIf="!HasThirdColumn">Answer <i class="fa fa-clipboard float-right" (click)="copyTable()" title="Copy Table" alt="Copy Table"></i></div>

        <div class="cell-data col-7 col-md-8" *ngIf="HasThirdColumn">Question</div>
        <div class="cell-data col-2 col-md-2" *ngIf="HasThirdColumn">Answer</div>
        <div class="cell-data col-2 col-md-2" *ngIf="HasThirdColumn && hasQuestionActions">Action <i class="fa fa-clipboard float-right" (click)="copyTable()" title="Copy Table" alt="Copy Table"></i></div>
        <div class="cell-data col-2 col-md-2" *ngIf="HasThirdColumn && displayScale">Scale <i class="fa fa-clipboard float-right" (click)="copyTable()" title="Copy Table" alt="Copy Table"></i></div>
    </div>
    <div *ngFor="let question of QuestionDisplays" [ngClass]="{flagged:question.isFlaggedForReview}" class="row">
        <div data-label="Question" class="col-8 col-md-9 cell-data prompt" [ngClass]="{'col-8 col-md-9': !HasThirdColumn, 'col-7 col-md-8': HasThirdColumn}">
            <h3 *ngIf="question.isFlaggedForReview" class='h3-responsive d-inline red-text'>
                <i class="fa fa-flag"></i>
            </h3>
            <em>{{question.prompt}}</em>
        </div>
        <div data-label="Answer" class="col-4 col-md-3 cell-data answer" [ngClass]="{'red-text':question.isFlaggedForReview, 'col-4 col-md-3': !HasThirdColumn, 'col-3 col-md-2': HasThirdColumn}">
            {{question.answerDisplayText}}
            <div class="d-inline-block" *hasPermission="'SuperUser'">({{question.computedScore}})</div>
        </div>
        <div data-label="Scale" class="cell-data col-2" *ngIf="shouldDisplayScale(question.scale)">{{question.scale}}</div>
        <div data-label="Action" class="cell-data col-2" *ngIf="shouldDisplayEmptyActionColumn(question)"></div>
        <div data-label="Action" class="cell-data col-2" *ngIf="shouldDisplayActionColumn(question)">
            <a (click)="handleAction(question)" class="btn btn-sm btn-secondary">{{question.actionLabel}}</a></div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/reports/scale-questions-list/scale-questions-list.component.html